
<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>
<section class="single_blog_area section_padding_80" style="font-style: open sans">
      <div class="container3 cent">
          <div class="row justify-content-center">
              <div class="col-sm-12 col-md-12  col-lg-8 col-xl-8" *ngIf="blog && blog.length > 0">
                          <div class="single-post">
                              <!-- Post Thumb -->
                              <div class="post-thumb">
                                  <img style="width:100%" src="https://passport.petcart.in/images/blogimage/{{blog[0].blogcoverimg}}" alt="">
                              </div>
                              <!-- Post Content -->
                              <div class="post-content">
                                  <div class="post-meta d-flex">
                                      <div class="post-author-date-area d-flex">
                                          <!-- Post Author -->
                                          <div class="post-author">
                                              <a href="#">By pet cart</a>
                                          </div>
                                          <!-- Post Date -->
                                          <div class="post-date">
                                              <a >{{blog[0].created_at | slice:0:10}}</a>
                                          </div>
                                      </div>
                                      <!-- Post Comment & Share Area -->
                                      <div class="post-comment-share-area d-flex">
                                          <!-- Post Comments -->
                                          <div class="post-comments">
                                              <a href="#"><i class="fa fa-comment-o" aria-hidden="true"></i>{{totalcomment}}</a>
                                          </div>
                                          <!-- Post Share -->
                                          <div class="post-share">
                                              <a href="#"><i class="fa fa-share-alt" aria-hidden="true"></i></a>
                                          </div>
                                      </div>
                                  </div>
                                  <a>
                                      <h2 class="post-headline">{{blog[0].title}}</h2>
                                  </a>
                                  <p [innerHTML]="blog[0].body"></p>




                              </div>
                          </div>
                          <!-- Comment Area Start -->
                      <!--    <div class="comment_area section_padding_50 clearfix" style="border-top:2px solid #9b7544" *ngIf="comment && comment.length > 0">
                              <h4 class="mb-30">{{totalcomment}} Comments</h4>

                              <ol style="margin-top:30px;" >
                                  <!-- Single Comment Area -->
                                <!--  <li class="single_comment_area" *ngFor=" let data of comment">
                                      <div class="comment-wrapper d-flex">
                                          <!-- Comment Meta -->
                                      <!--    <div class="comment-author">
                                              <img src="https://passport.petcart.in/images/userimgs/{{userimgarray['id'+data.user_id]}}" alt="">
                                          </div>
                                          <!-- Comment Content -->
                                        <!--  <div class="comment-content">
                                              <span class="comment-date text-muted">{{data.updated_at | slice :10}}</span>
                                              <h5>{{usernamearray['id'+data.user_id]}}</h5>
                                              <p>{{data.comment}}</p>
                                          </div>
                                      </div>
                                  </li>
                              </ol>
                          </div>-->

                          <!-- Leave A Comment -->
                       <!--   <div class="leave-comment-area section_padding_50 clearfix" *ngIf="userStatus == 1; else loginsection">
                            <div class="comment-wrapper d-flex">
                            <div class="comment-author" *ngIf="user">
                                <img src="https://passport.petcart.in/images/userimgs/{{user[0].image}}" alt="">
                            </div>
                            <!-- Comment Content -->
                           <!-- <div class="comment-content" *ngIf="user">

                                <h5>{{user[0].name}}</h5>

                            </div>
                        </div>
                            <div class="comment-form" *ngIf="upstatus === 0; else posted">
                                  <h4 class="mb-30">Leave A Comment</h4>

                                  <!-- Comment Form -->
                               <!--   <form>
                                      <div class="form-group">
                                          <textarea class="form-control" name="message" id="message"
                                          cols="30" rows="10" placeholder="Message" [(ngModel)]="message" required></textarea>
                                      </div>
                                      <button (click)="uploadComments()" class="btn btn-success contact-btn" *ngIf="message">Post Comment</button>
                                  </form>
                              </div>
                          </div>-->
              </div>
              <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4" *ngIf="rblog && rblog.length > 1">
                        <!-- Single Widget Area -->
                        <div class="single-widget-area popular-post-widget">
                            <div class="widget-title text-center">
                                <h6>Related Post</h6>
                            </div>
                            <div class="row">
                                <div class="col-sm-12" *ngFor="let data of rblog"
                                (click)="changeBlog(data.id,data.url)" style="cursor: pointer">
                                     <!-- Single Popular Post -->
                                    <div class="single-populer-post d-flex" *ngIf="data.id !== blog[0].id">
                                    <img src="https://passport.petcart.in/images/blogimage/{{data.blogcoverimg}}" alt="">
                                            <div class="post-content" style="color: #9b7544">
                                            <a>
                                                <h6>{{data.title}}</h6>
                                            </a>
                                            <p>{{data.created_at | slice : 0: 10 }}</p>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
              </div>
          </div>
      </div>
  </section>

   <ng-template #loginsection>
       <div class="row">
           <div class="col-sm-6 col-md-12 col-lg-6 col-xl-6">
            <p style="font-style: open sans ; color: #9b7544;overflow-wrap: break-word;
            font-size:20px">
                Do you want to post your comment , So plz Login
            </p>
           </div>
           <div class="col-sm-6 col-md-12 col-lg-6 col-xl-6">
            <button class="btn btn-success btn-block" (click)="login()">Login Here</button>
        </div>
       </div>
   </ng-template>
   <ng-template #posted>
       <div class="row">
           <div class="col-12 text-center">
               <p style="font-style: open sans ; color: #9b7544;overflow-wrap: break-word;
               font-size:20px">Your Cmment has been published affter Verification.
               our backend team will verify your post as early as possible.
            </p>
           </div>
       </div>
   </ng-template>
